"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var h = require("./../../utils/createElement").h;
var React = tslib_1.__importStar(require("react"));
var react_dom_1 = tslib_1.__importDefault(require("react-dom"));
var helper_1 = require("../../utils/helper");
var keepDom_1 = require("../../utils/keepDom");
var Spin_1 = tslib_1.__importDefault(require("../Loading/Spin"));
var context_1 = require("./context");
var theme_1 = require("../../utils/theme");
var queue_1 = require("./queue");
var constant_1 = require("./constant");
var locale_1 = require("../../common/locale");
var Snackbar = (function (_super) {
    tslib_1.__extends(Snackbar, _super);
    function Snackbar() {
        var _a;
        var _this = _super.apply(this, arguments) || this;
        _this.selfRef = React.createRef();
        _this.disableAutoFocus = helper_1.isBrowser && ((_a = window.__dui_disable_auto_focus_map__) === null || _a === void 0 ? void 0 : _a.Snackbar);
        _this.handleClickAction = function () {
            _this.getEffectiveProps().onClickAction();
            _this.handleClose();
        };
        _this.handleClickClose = function () {
            _this.getEffectiveProps().onClickClose();
            _this.handleClose();
        };
        _this.handleClose = function () {
            _this.getEffectiveProps().onClose();
        };
        _this.themedRender = function (classNames) {
            var _a;
            var _b = _this.getEffectiveProps(), prefixCls = _b.prefixCls, className = _b.className, style = _b.style, action = _b.action, children = _b.children, message = _b.message, visible = _b.visible, closable = _b.closable, type = _b.type, zIndex = _b.zIndex, showIcon = _b.showIcon, testId = _b.testId, emphasize = _b.emphasize;
            var placement = 'top';
            var messageCls = classNames(prefixCls + "-message");
            if (!keepDom_1.decideKeepDom.call(_this, constant_1.SNACKBAR_LEAVING_TRANSITION_DURATION, visible)) {
                return null;
            }
            var containerDom = _this.getContainerDom();
            var cls = classNames(prefixCls, className, prefixCls + "-" + placement, prefixCls + "-" + type, (_a = {},
                _a[prefixCls + "-emphasize"] = emphasize,
                _a[prefixCls + "-with-icon"] = showIcon && !_this.renderUserSetIcon(classNames),
                _a[prefixCls + "-hidden"] = !visible,
                _a[prefixCls + "-in-container"] = containerDom !== document.body,
                _a));
            return react_dom_1.default.createPortal(h("div", { className: cls, style: tslib_1.__assign({ zIndex: zIndex, marginTop: queue_1.getMarginTop(_this) + "px" }, style), ref: _this.selfRef, role: "alert", "aria-live": "assertive", "aria-atomic": true, "data-testid": testId },
                _this.renderIcon(classNames),
                h("span", { className: messageCls }, children || message),
                (action || closable) ?
                    h("span", { className: classNames(prefixCls + "-controls") },
                        _this.renderAction(classNames),
                        _this.renderClose(classNames))
                    : null), containerDom);
        };
        return _this;
    }
    Snackbar.prototype.getContainerDom = function () {
        return helper_1.isDom(this.context) ? this.context : this.getEffectiveProps().containerDom;
    };
    Snackbar.prototype.getEffectiveProps = function () {
        var _a = this.props, type = _a.type, emphasize = _a.emphasize;
        if (!['error', 'warning'].includes(type)) {
            return this.props;
        }
        if (type === 'warning') {
            return tslib_1.__assign(tslib_1.__assign({}, this.props), { type: 'error', emphasize: false });
        }
        if (type === 'error' && emphasize === undefined) {
            return tslib_1.__assign(tslib_1.__assign({}, this.props), { type: 'error', emphasize: true });
        }
        return this.props;
    };
    Snackbar.prototype.componentDidMount = function () {
        this.handleEffect();
    };
    Snackbar.prototype.componentDidUpdate = function () {
        this.handleEffect();
    };
    Snackbar.prototype.handleEffect = function () {
        queue_1.updateVisibleSnackbars(this);
    };
    Snackbar.prototype.renderUserSetIcon = function (classNames) {
        var _a = this.getEffectiveProps(), prefixCls = _a.prefixCls, type = _a.type, showIcon = _a.showIcon, icon = _a.icon;
        if (!showIcon || !icon) {
            return null;
        }
        if (React.isValidElement(icon)) {
            return h("div", { className: classNames(prefixCls + "-icon-container") }, icon);
        }
        if (typeof icon === 'object') {
            var passedType = this.props.type;
            var resolvedIcon = icon[passedType] || icon[type];
            return h("div", { className: classNames(prefixCls + "-icon-container") }, resolvedIcon);
        }
        return null;
    };
    Snackbar.prototype.renderAction = function (classNames) {
        var _this = this;
        var _a = this.getEffectiveProps(), prefixCls = _a.prefixCls, action = _a.action;
        if (!action) {
            return null;
        }
        if (Array.isArray(action) && action.length > 0 && action[0].text) {
            return (h("span", { className: classNames(prefixCls + "-actions") }, action.map(function (a, index) {
                return h("button", { key: index, className: classNames(prefixCls + "-action"), onClick: function () {
                        var _a;
                        (_a = a.onClick) === null || _a === void 0 ? void 0 : _a.call(a);
                        _this.handleClose();
                    }, autoFocus: !_this.disableAutoFocus && index === 0 }, a.text);
            })));
        }
        return (h("button", { className: classNames(prefixCls + "-action"), onClick: this.handleClickAction, autoFocus: !this.disableAutoFocus }, action));
    };
    Snackbar.prototype.renderIcon = function (classNames) {
        var _a = this.getEffectiveProps(), prefixCls = _a.prefixCls, spinType = _a.spinType, type = _a.type, showIcon = _a.showIcon;
        if (!showIcon) {
            return null;
        }
        var userSetIcon = this.renderUserSetIcon(classNames);
        if (userSetIcon) {
            return userSetIcon;
        }
        return type === 'loading' ?
            h(Spin_1.default, { type: spinType, className: classNames(prefixCls + "-loading-indicator"), circleClassName: classNames(prefixCls + "-loading-indicator-circle") })
            : null;
    };
    Snackbar.prototype.renderClose = function (classNames) {
        var _a = this.getEffectiveProps(), prefixCls = _a.prefixCls, closable = _a.closable;
        return closable ?
            h("button", { className: classNames(prefixCls + "-close"), onClick: this.handleClickClose, "aria-label": locale_1.i18n('close') })
            : null;
    };
    Snackbar.prototype.render = function () {
        return theme_1.consumeTheme(this.themedRender);
    };
    Snackbar.contextType = context_1.ContainerContext;
    return Snackbar;
}(React.Component));
exports.default = Snackbar;
Snackbar.defaultProps = {
    prefixCls: 'dui-snackbar',
    onClickAction: helper_1.emptyFn,
    closable: false,
    type: 'info',
    onClose: helper_1.emptyFn,
    showIcon: true,
    containerDom: typeof document !== 'undefined' ? document.body : undefined,
    spinType: 'primary',
    onClickClose: helper_1.emptyFn,
};
